const AppKeys = {
  emailJsPublicKey: "PcFR-tATtXu5uyJpn",
  emailJsTemplatId: "template_hcy10rs",
  emailJsServiceId: "service_q30ltaj",
};

export default AppKeys;

